import React, {useMemo} from 'react';
import {useEditorFrame} from './useEditorFrame';
import {editorHtml} from './wordProcessorDocument';

export default function AdvancedWordProcessor({value, onChange, readOnly = false, preserveViewport = false}) {
    const options=useMemo(()=>readOnly || preserveViewport ? {readOnly,preserveViewport} : undefined,[readOnly,preserveViewport]);
    const {iframeRef, onLoad}=useEditorFrame(value,readOnly ? undefined : onChange,'editor',options);
    return <div className="w-full h-full min-h-0 flex flex-col"><iframe ref={iframeRef} onLoad={onLoad} srcDoc={editorHtml} className="w-full h-full border rounded-lg" title="Advanced Word Processor" style={{height:'500px',minHeight:0,flex:'1 1 auto'}}/></div>;
}
